export interface SupplierDialogData {
    abn: string;
    businessName: string;
    supplierAddress: string;
  }
  
  export interface SupplierDialogResult {
    valid: boolean;
  }